import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-json-preview',
  templateUrl: './json-preview.component.html',
})
export class JsonPreviewComponent {
  @Input()
  json: object;

  constructor(public modal: NgbActiveModal) {}
}
